import type { ReactNode } from "react";

export interface ShowOnSmOrMdScreenProps {
  children: ReactNode;
}

export const ShowOnSmOrMdScreen = ({ children }: ShowOnSmOrMdScreenProps) => (
  <div className="md:hidden">{children}</div>
);
